export enum HeaderClassType {
  My = "my",
  Clearfix = "clearfix"
}
